<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputTextarea name="Note" v-model="element.notes" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>